import type { BrandConfig } from '../types'
import placeholderImage from './assets/placeholder.svg'
import logoImage from './assets/logo.svg'
import testimonial1 from './assets/testimonial-1.svg'
import testimonial2 from './assets/testimonial-2.svg'
import testimonial3 from './assets/testimonial-3.svg'

const config: BrandConfig = {
  appName: 'TuneCore',
  brandName: 'TuneCore',
  description: 'Sistema de agendamento para estúdios de gravação',
  logo: {
    src: logoImage,
    alt: 'Logótipo da marca',
  },
  heroImage: {
    src: placeholderImage,
    alt: 'Estúdio de gravação profissional',
  },
  serviceImage: {
    src: placeholderImage,
    alt: 'Músico gravando em estúdio',
  },
  testimonials: [
    {
      name: 'Zé Pedro',
      role: 'Produtor Musical',
      text: 'O TuneCore é perfeito para gerir as reservas do estúdio. Os músicos podem ver a disponibilidade e marcar online.',
      image: testimonial1,
    },
    {
      name: 'A Banda da Garagem',
      role: 'Músicos',
      text: 'Finalmente uma forma de marcar os nossos ensaios e gravações sem confusões de horários.',
      image: testimonial2,
    },
    {
      name: 'Estúdios Som Maior',
      role: 'Gerente',
      text: 'Otimizámos a ocupação das nossas salas de gravação e a satisfação dos nossos clientes aumentou.',
      image: testimonial3,
    },
  ],
  terminology: {
    professional: 'produtor',
    professionals: 'produtores',
    business: 'estúdio',
    businesses: 'estúdios',
    service: 'gravação',
    services: 'gravações',
    client: 'artista',
    clients: 'artistas',
    appointment: 'sessão',
    appointments: 'sessões',
  },
  homepage: {
    hero: {
      badge: 'Produção Musical',
      title: 'Grave grandes sucessos com TuneCore',
      description: 'Organize suas sessões de gravação e produza música de qualidade profissional com o TuneCore.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Agendar Demonstração',
      features: ['Setup em 5 minutos', 'App mobile incluído'],
    },
    statistics: [
      { value: '150+', label: 'Produtores' },
      { value: '8k+', label: 'Gravações Realizadas' },
      { value: '98%', label: 'Satisfação' },
    ],
    painPoints: [
      {
        title: 'Conflitos de Horário',
        description: 'Múltiplas bandas marcando o mesmo horário causa stress e perda de clientes.',
        icon: 'Clock',
        quote: {
          text: 'Antes do TuneCore perdia bandas por dupla marcação, agora nunca mais acontece',
          author: 'Rui Silva',
          business: 'Sound Factory Studios',
        },
      },
      {
        title: 'Equipamento Inadequado',
        description: 'Sem saber antecipadamente o tipo de gravação, é difícil preparar equipamentos específicos.',
        icon: 'Mic',
        stats: [
          { label: 'Sessões com equipamento errado:', value: '25%' },
          { label: 'Tempo perdido em setup:', value: '2h/dia' },
        ],
      },
      {
        title: 'Gestão de Projetos',
        description: 'Acompanhar múltiplos álbuns e projetos sem sistema digital é caótico.',
        icon: 'FolderOpen',
        quote: {
          text: 'Com o controlo de projetos consigo acompanhar cada álbum desde o primeiro take até à masterização',
          author: 'Ana Santos',
          business: 'Melody Studios',
        },
      },
    ],
    solution: {
      badge: 'A Solução',
      title: 'TuneCore: O seu estúdio inteligente',
      description: 'Tecnologia musical para produtores que criam arte sonora de qualidade.',
      features: [
        {
          title: 'Reserva por Sala',
          description: 'Diferentes salas (gravação, mixagem, masterização) com equipamentos específicos.',
        },
        {
          title: 'Setup Automático',
          description: 'Cada tipo de sessão prepara lista de equipamentos necessários automaticamente.',
        },
        {
          title: 'Gestão de Projetos',
          description: 'Acompanhe progresso de álbuns, demos e singles com timeline visual.',
        },
      ],
    },
    testimonials: {
      title: 'O que os produtores dizem',
      description: 'Produtores que elevaram a qualidade musical com o TuneCore.',
    },
    finalCta: {
      title: 'Pronto para produzir hits?',
      description: 'Junte-se aos produtores que já organizaram seus estúdios com o TuneCore.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Ver Demonstração',
    },
    contact: {
      title: 'Fale Conosco',
    },
  },
  auth: {
    register: {
      title: 'Criar uma conta',
      description: 'Preencha os dados abaixo para se registrar',
      inviteDescription: 'Crie sua conta para aceitar o convite de produtor',
      subscriptionDescription: 'Crie sua conta para finalizar sua assinatura',
      inviteCodeLabel: 'Você está usando um código de convite',
      subscriptionLabel: 'Você selecionou um plano de assinatura',
    },
    login: {
      title: 'Entrar na conta',
      description: 'Digite suas credenciais para acessar',
    },
  },
}

export default config